$.fn.downloadOrganisationsOnClick = function () {
  var DCLG = window.DCLG;
  var $DIALOG;
  var URLS = {};

  this.each(function () {
    var $self = $(this);

    if ($self.attr("href")) {

      $self.on("click", function (event) {
        event.preventDefault();

        clearMessageInPage();


        URLS.destU = $self.attr("href");
        URLS.valU = URLS.destU;
        //                URLS.valU = '/submissions/allow-download.json';
        var baseUrl = $self.attr("href");

        var sym = URLS.destU.indexOf("?") === -1 ? "?" : "&";

        var queryParams = DCLG.DataGrid.instance.dclg.params;
        if (!$.isEmptyObject(queryParams)) {
          URLS.destU = URLS.destU + sym + $.param(queryParams);
          URLS.valU += "?" + $.param(queryParams);
          baseUrl += "?" + $.param(queryParams);
        }


        var dateTime = "";

        redirectTo(baseUrl);
      });
    }
  });

  function redirectTo(u) {
    window.location.href = u;
    //          console.log('redirecting to url : '+u)
  }

  function buildDialog(builder) {
    var $dialog = $("#" + builder.id);

    if ($dialog) {
      // Title
      $dialog.find(".dialog-title").text(builder.title);

      // Buttons
      $.each(builder.buttons, function () {
        $dialog
          .find(".dialog-buttons button.dialog-" + this.type)
          .text(this.text)
          .addClass(this.extraClasses);
      });

      // Color Scheme
      $dialog
        .find(".icon.fa")
        .removeClass("fa-icontype")
        .addClass("fa-" + builder.colorScheme);

      // Event Handler for button-clicks
      $dialog.find(".dialog-buttons button").on("click", function (e) {
        e.preventDefault();

        // Event trigger for closing the dialog
        $dialog.trigger("dialog.close.exportdap", {
          button: e.target,
          destU: URLS.destU,
        });
      });
    }

    return $dialog;
  }

  function clearMessageInPage() {
    $("#message p").text("");
  }

  function showMessageInPage(msgType, msg) {
    var msgStyleColor = {};
    // Set CSS styles
    switch (msgType.toLowerCase()) {
      case "info":
        msgStyleColor.color = "blue";
      case "success":
        msgStyleColor.color = "green";
      case "warning":
        msgStyleColor.color = "orange";
      case "error":
      default:
        msgStyleColor.color = "red";
    }
    // Apply CSS style
    $("#message p").css(msgStyleColor).text(msg);
  }

  function closeDialog(e, trigger) {
    e.preventDefault();

    // Close the dialog
    e.target.close();

    // Remove indicators which show the dialog as being 'open'
    $("body").removeClass("dialog-is-open");

    // Decide whether to honour the DownloadCSV request, based on user feedback
    if ($(trigger.button).hasClass("dialog-proceed")) {
      console.log(
        "You chose to PROCEED with your Download*** request",
        trigger,
      );
      redirectToDownload(trigger.destU);
    } else {
    }
  }

  function isInDataStorePage() {
    return $("#datastore-page").length > 0;
  }

  function isInTestDataStorePage() {
    return $("#test-datastore-page").length > 0;
  }

  function setError(error) {
    $("#error").text(error);
    $("#errorBlock").removeClass("visually-hidden");
  }
  //    function showDialog(message) {
  //
  //        // Add dialog message
  //        $DIALOG.find('.dialog-message')
  //                    .text(message);
  //
  //        // Include indicators to show the dialog as being 'open'
  //        $('body').addClass('dialog-is-open');
  //
  //        //  Now show the dialog...
  //        $DIALOG[0].showModal();
  //    }
};
